/* eslint-disable jsx-a11y/anchor-is-valid */
// import React, { FC, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import React, { FC } from 'react'

// import { createPortal } from 'react-dom'
// import { useIntl } from 'react-intl'
// import { PageTitle } from '../../../_metronic/layout/core'
// import { GoogleMap, LoadScript, Marker, MarkerClusterer, Polyline } from '@react-google-maps/api'
// import userPermissionContext from '../../../context/userPermissionContext'


const DashboardPage: FC = () => (
	<></>
)

// const parseDurationToSec = (text: string = '') => {
// 	if (!text || typeof text !== 'string') return 0
// 	const h = Number((text.match(/(\d+)\s*h/) || [])[1] || 0)
// 	const m = Number((text.match(/(\d+)\s*min/) || [])[1] || 0)
// 	const s = Number((text.match(/(\d+)\s*s/) || [])[1] || 0)
// 	return h * 3600 + m * 60 + s
// }

// const toNum = (value: any, fallback = 0) => {
// 	const n = Number(value)
// 	return Number.isFinite(n) ? n : fallback
// }

// const MAX_TRACK_POINTS = 30
// const MAX_ROUTE_SAMPLE_POINTS = 25
// const MAX_ALERTS = 30
// const ALERT_TTL_MS = 90 * 1000
// const SPEED_LIMIT_KMH = 80
// const OFFLINE_THRESHOLD_MS = 6 * 3600 * 1000

// // Captured once at module load. CRA 4 webpack inlines these, but reading
// // them via constants also makes hot-reload safer (some HMR runtimes lose the
// // `process` global between rebuilds → "process is not defined").
// const API_URL = process.env.REACT_APP_API_URL || ''
// const MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY || ''

// type AlertSeverity = 'success' | 'warning' | 'danger' | 'info'
// type AlertEvent = {
// 	id: string
// 	type: 'overspeed' | 'started_moving' | 'stopped' | 'online' | 'offline' | 'long_idle'
// 	severity: AlertSeverity
// 	title: string
// 	vehicle: string
// 	at: number
// }

// const vehicleKey = (item: any) => String(item?.device_name || item?.name || item?.id || '')

// // Best-effort parser for the upstream time fields (`time`, `device_time`,
// // `datetime`). Tries: numeric epoch (sec or ms), ISO strings, and the
// // MySQL-style "YYYY-MM-DD HH:MM:SS" which Safari refuses to parse with the
// // raw Date constructor — we patch the space → 'T' and tack on a 'Z' if no
// // timezone is present.
// const parseTrackTime = (input: any): number => {
// 	if (input === null || input === undefined || input === '') return NaN
// 	if (typeof input === 'number' && Number.isFinite(input)) {
// 		return input < 1e12 ? input * 1000 : input
// 	}
// 	const raw = String(input).trim()
// 	if (!raw) return NaN
// 	const direct = new Date(raw).getTime()
// 	if (Number.isFinite(direct)) return direct
// 	// Convert "YYYY-MM-DD HH:MM:SS[.fff]" → "YYYY-MM-DDTHH:MM:SS[.fff]Z"
// 	const isoLike = raw.replace(' ', 'T')
// 	const withZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(isoLike) ? isoLike : `${isoLike}Z`
// 	const fallback = new Date(withZone).getTime()
// 	return Number.isFinite(fallback) ? fallback : NaN
// }

// // Human-readable "X seconds/minutes ago" used in the InfoWindow timestamp.
// // Tiny clock-drift negatives (e.g. device a few seconds ahead of the
// // browser) collapse to "just now" instead of an em-dash so the UI doesn't
// // look broken when the device clock and browser clock disagree slightly.
// const formatRelativeTime = (ms: number): string => {
// 	if (!Number.isFinite(ms)) return '—'
// 	if (ms < 0) {
// 		if (ms > -60_000) return 'just now'
// 		return '—'
// 	}
// 	const sec = Math.floor(ms / 1000)
// 	if (sec < 5) return 'just now'
// 	if (sec < 60) return `${sec}s ago`
// 	const min = Math.floor(sec / 60)
// 	if (min < 60) return `${min}m ago`
// 	const hr = Math.floor(min / 60)
// 	if (hr < 24) return `${hr}h ${min % 60}m ago`
// 	const days = Math.floor(hr / 24)
// 	return `${days}d ${hr % 24}h ago`
// }

// // "Hh Mm Ss" pretty-printer for raw second counts (e.g. stop duration when the
// // upstream string is missing or malformed).
// const formatDurationSec = (sec: number): string => {
// 	if (!Number.isFinite(sec) || sec <= 0) return '—'
// 	const h = Math.floor(sec / 3600)
// 	const m = Math.floor((sec % 3600) / 60)
// 	const s = Math.floor(sec % 60)
// 	if (h > 0) return `${h}h ${m}m`
// 	if (m > 0) return `${m}m ${s}s`
// 	return `${s}s`
// }

// // 16-point compass for the InfoWindow heading row.
// const CARDINAL_DIRECTIONS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW']
// const bearingToCardinal = (bearing: number): string => {
// 	if (!Number.isFinite(bearing)) return '—'
// 	const idx = Math.round(((bearing % 360) + 360) % 360 / 22.5) % 16
// 	return CARDINAL_DIRECTIONS[idx]
// }

// const formatLatLng = (lat: number, lng: number) => `${lat.toFixed(5)}, ${lng.toFixed(5)}`
// const addressCache = new Map<string, string>()

// // Google's geocoder often prefixes addresses with an Open Location Code / Plus Code
// // (e.g. "RVXV+VX9, Moglabazar Rd, Bangladesh"). Strip that prefix so the UI shows
// // just the human-readable street/area portion.
// const PLUS_CODE_PREFIX = /^\s*[A-Z0-9]{4,8}\+[A-Z0-9]{2,4}\s*,\s*/i
// const PLUS_CODE_ONLY = /^\s*[A-Z0-9]{4,8}\+[A-Z0-9]{2,4}\s*$/i
// const cleanAddress = (text: string): string => {
// 	if (!text) return ''
// 	let cleaned = text.replace(PLUS_CODE_PREFIX, '').trim()
// 	if (PLUS_CODE_ONLY.test(cleaned)) cleaned = ''
// 	return cleaned
// }

// const sampleRoutePoints = (path: { lat: number; lng: number }[], maxPoints = MAX_ROUTE_SAMPLE_POINTS) => {
// 	if (!Array.isArray(path) || path.length <= 2) return path
// 	const step = Math.max(1, Math.ceil(path.length / maxPoints))
// 	const sampled = path.filter((_, index) => index % step === 0)
// 	const first = path[0]
// 	const last = path[path.length - 1]
// 	if (sampled[0] !== first) sampled.unshift(first)
// 	if (sampled[sampled.length - 1] !== last) sampled.push(last)
// 	return sampled.slice(0, maxPoints - 1).concat(last)
// }

// const haversineKm = (lat1: number, lng1: number, lat2: number, lng2: number) => {
// 	const toRad = (deg: number) => (deg * Math.PI) / 180
// 	const R = 6371
// 	const dLat = toRad(lat2 - lat1)
// 	const dLng = toRad(lng2 - lng1)
// 	const a =
// 		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
// 		Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
// 	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
// 	return R * c
// }

// const getBearingDeg = (lat1: number, lng1: number, lat2: number, lng2: number) => {
// 	const toRad = (deg: number) => (deg * Math.PI) / 180
// 	const toDeg = (rad: number) => (rad * 180) / Math.PI
// 	const dLng = toRad(lng2 - lng1)
// 	const y = Math.sin(dLng) * Math.cos(toRad(lat2))
// 	const x =
// 		Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
// 		Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLng)
// 	const brng = toDeg(Math.atan2(y, x))
// 	return (brng + 360) % 360
// }

// // Shortest-arc angle interpolation: rotates via the shorter direction
// // (e.g. 350° -> 10° goes +20° clockwise instead of -340° counter-clockwise).
// const lerpAngle = (a: number, b: number, t: number) => {
// 	const diff = ((((b - a) % 360) + 540) % 360) - 180
// 	return (a + diff * t + 360) % 360
// }

// // Uber-style top-down car icon. Built as an inline SVG data-URL so we can use
// // multiple colors (body / windshield / headlights). Pre-rotated to `bearing`
// // (degrees clockwise from north) and tinted by `color`.
// //
// // Performance: the bearing is bucketed to 2° steps and the resulting URL is
// // cached forever (180 buckets × 2 colors ≈ 360 unique URLs). This avoids
// // rebuilding/encoding the SVG on every animation frame for every marker.
// const ICON_URL_CACHE = new Map<string, string>()
// const BEARING_BUCKET_DEG = 2
// // Highlight color used for the selection halo around the focused vehicle.
// const SELECTION_HIGHLIGHT_COLOR = '#2563eb'
// const buildCarIconUrl = (bearing: number, color: string, isSelected = false) => {
// 	const bucket = ((Math.round(bearing / BEARING_BUCKET_DEG) * BEARING_BUCKET_DEG) % 360 + 360) % 360
// 	const cacheKey = `${bucket}|${color}|${isSelected ? 'sel' : 'nrm'}`
// 	const cached = ICON_URL_CACHE.get(cacheKey)
// 	if (cached) return cached
// 	// Selected vehicles render in a larger viewport with a soft glow + bright
// 	// halo ring around the car so it stands out on dense maps. Non-selected
// 	// vehicles keep the old 44×44 layout exactly so existing offsets/anchors
// 	// are unaffected.
// 	const size = isSelected ? 64 : 44
// 	const half = size / 2
// 	const halo = isSelected
// 		? `<circle cx="0" cy="0" r="22" fill="${SELECTION_HIGHLIGHT_COLOR}" opacity="0.18"/>` +
// 		  `<circle cx="0" cy="0" r="16" fill="none" stroke="${SELECTION_HIGHLIGHT_COLOR}" stroke-width="2.6" opacity="0.95"/>`
// 		: ''
// 	const svg =
// 		`<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="-${half} -${half} ${size} ${size}">` +
// 		halo +
// 		`<g transform="rotate(${bucket} 0 0)">` +
// 		`<ellipse cx="0" cy="2" rx="9" ry="14" fill="rgba(0,0,0,0.18)"/>` +
// 		`<rect x="-7.5" y="-13.5" width="15" height="27" rx="3.5" ry="3.5" fill="${color}" stroke="#ffffff" stroke-width="1.2"/>` +
// 		`<path d="M -5.5 -10 L 5.5 -10 L 4.5 -4 L -4.5 -4 Z" fill="#bfe0ff" opacity="0.95"/>` +
// 		`<path d="M -4.5 5 L 4.5 5 L 5.5 10 L -5.5 10 Z" fill="#bfe0ff" opacity="0.6"/>` +
// 		`<rect x="-6.2" y="-13" width="2.4" height="1.8" rx="0.6" fill="#fff8c2"/>` +
// 		`<rect x="3.8" y="-13" width="2.4" height="1.8" rx="0.6" fill="#fff8c2"/>` +
// 		`<rect x="-6.2" y="11.2" width="2.4" height="1.6" rx="0.5" fill="#ff5b5b"/>` +
// 		`<rect x="3.8" y="11.2" width="2.4" height="1.6" rx="0.5" fill="#ff5b5b"/>` +
// 		`</g></svg>`
// 	const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
// 	ICON_URL_CACHE.set(cacheKey, url)
// 	return url
// }

// // Hoisted so referential equality is stable across renders → keeps Marker props stable.
// const MARKER_OPTIONS = { optimized: false } as const
// const MOVING_COLOR = '#111111'
// const IDLE_COLOR = '#6c757d'

// // Memoized vehicle marker: only re-renders when its own primitive props change.
// // During animation, stationary vehicles' lat/lng/bearing don't change, so they
// // completely skip reconciliation while moving vehicles continue to update.
// type VehicleMarkerProps = {
// 	item: any
// 	lat: number
// 	lng: number
// 	bearing: number
// 	isMoving: boolean
// 	isSelected: boolean
// 	iconSize?: google.maps.Size
// 	iconAnchor?: google.maps.Point
// 	iconSizeSelected?: google.maps.Size
// 	iconAnchorSelected?: google.maps.Point
// 	onClick: (item: any) => void
// 	clusterer?: any
// }
// // The marker no longer shows a floating "<name> (<speed> km/h)" label — that
// // information is now displayed in the vehicle detail modal that opens on click,
// // so duplicating it on top of the icon was redundant and noisy on dense maps.
// // When selected, the marker renders in a larger viewport with a colored halo
// // ring so it's instantly identifiable on the map (especially when the user
// // reached it from the Recent Activity panel rather than clicking the marker).
// const VehicleMarker = React.memo<VehicleMarkerProps>(
// 	({ item, lat, lng, bearing, isMoving, isSelected, iconSize, iconAnchor, iconSizeSelected, iconAnchorSelected, onClick, clusterer }) => {
// 		const color = isMoving ? MOVING_COLOR : IDLE_COLOR
// 		return (
// 			<Marker
// 				position={{ lat, lng }}
// 				onClick={() => onClick(item)}
// 				clusterer={clusterer}
// 				options={MARKER_OPTIONS}
// 				zIndex={isSelected ? 9999 : undefined}
// 				icon={{
// 					url: buildCarIconUrl(bearing, color, isSelected),
// 					scaledSize: isSelected ? iconSizeSelected : iconSize,
// 					anchor: isSelected ? iconAnchorSelected : iconAnchor,
// 				}}
// 			/>
// 		)
// 	}
// )
// VehicleMarker.displayName = 'VehicleMarker'

// const DashboardWrapper: FC = () => {

// 	const intl = useIntl()
// 	const permission = useContext(userPermissionContext as React.Context<any>)
// 	const jwt = permission?.jwt
// 	const [liveData, setLiveData] = useState<any[]>([])
// 	const [isLoading, setIsLoading] = useState(false)
// 	const [lastUpdatedAt, setLastUpdatedAt] = useState<number | null>(null)
// 	const [streamStatus, setStreamStatus] = useState<'connecting' | 'live' | 'reconnecting' | 'fallback'>('connecting')
// 	const [secondsSinceUpdate, setSecondsSinceUpdate] = useState(0)
// 	const [alerts, setAlerts] = useState<AlertEvent[]>([])
// 	const prevDataRef = useRef<Record<string, any>>({})
// 	const isFirstFrameRef = useRef(true)
// 	const [selectedMarker, setSelectedMarker] = useState<any>(null)
// 	const [focusedVehicle, setFocusedVehicle] = useState<any>(null)
// 	const [vehicleTracks, setVehicleTracks] = useState<Record<string, any[]>>({})
// 	const [vehicleBearings, setVehicleBearings] = useState<Record<string, number>>({})
// 	const [animatedPositions, setAnimatedPositions] = useState<Record<string, { lat: number; lng: number }>>({})
// 	const [animatedBearings, setAnimatedBearings] = useState<Record<string, number>>({})
// 	const [snappedTargets, setSnappedTargets] = useState<Record<string, { lat: number; lng: number }>>({})
// 	const snapCacheRef = useRef<Map<string, { lat: number; lng: number }>>(new Map())
// 	const [mapCenterOverride, setMapCenterOverride] = useState<{ lat: number; lng: number } | null>(null)
// 	const [initialMapCenter, setInitialMapCenter] = useState<{ lat: number; lng: number } | null>(null)
// 	const [mapsReady, setMapsReady] = useState(false)
// 	const [snappedSelectedTrack, setSnappedSelectedTrack] = useState<{ lat: number; lng: number }[]>([])
// 	const [isSelectedTrackSnapped, setIsSelectedTrackSnapped] = useState(false)
// 	const [selectedLocationName, setSelectedLocationName] = useState('')
// 	const [vehicleAddresses, setVehicleAddresses] = useState<Record<string, string>>({})
// 	const mapRef = useRef<google.maps.Map | null>(null)
// 	const animationRef = useRef<number | null>(null)
// 	const distanceAnimationRef = useRef<number | null>(null)
// 	const animatedPositionsRef = useRef<Record<string, { lat: number; lng: number }>>({})
// 	const animatedBearingsRef = useRef<Record<string, number>>({})
// 	const displayedDistanceRef = useRef(0)
// 	const jwtTokenRef = useRef<string | undefined>(jwt?.token)
// 	const getLiveLocationRef = useRef<() => void>(() => {})
// 	const [displayDistanceKm, setDisplayDistanceKm] = useState(0)

// 	useEffect(() => {
// 		jwtTokenRef.current = jwt?.token
// 	}, [jwt?.token])

// 	const getLiveLocation = useCallback(() => {
// 		const trackerToken = localStorage.getItem('TrackerToken')
// 		const token = jwtTokenRef.current
// 		if (!trackerToken || !token) return

// 		setIsLoading(true)
// 		const requestOptions = {
// 			method: 'POST',
// 			headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
// 			body: JSON.stringify({ tracker_token: trackerToken }),
// 		}

// 		fetch(API_URL + 'liveTracData', requestOptions)
// 			.then((resp) => resp.json())
// 			.then((resp) => {
// 				if (resp?.success === true && Array.isArray(resp?.data)) {
// 					setLiveData(resp.data)
// 					setLastUpdatedAt(Date.now())
// 				}
// 			})
// 			.catch(() => {
// 				setLiveData([])
// 			})
// 			.finally(() => {
// 				setIsLoading(false)
// 			})
// 	}, [])

// 	useEffect(() => {
// 		getLiveLocationRef.current = getLiveLocation
// 	}, [getLiveLocation])

// 	// Real-time stream via Server-Sent Events. The backend polls the upstream
// 	// carcopolo API every ~3s and pushes deduplicated updates here. EventSource
// 	// auto-reconnects on network failures, so we don't need our own retry loop.
// 	useEffect(() => {
// 		const token = jwt?.token
// 		const trackerToken = localStorage.getItem('TrackerToken')
// 		if (!token || !trackerToken) return

// 		// One-shot initial fetch so the dashboard isn't empty while SSE connects.
// 		getLiveLocationRef.current()

// 		const url =
// 			`${API_URL}liveTracStream` +
// 			`?token=${encodeURIComponent(token)}` +
// 			`&tracker_token=${encodeURIComponent(trackerToken)}`

// 		let es: EventSource | null = null
// 		let fallbackInterval: ReturnType<typeof setInterval> | null = null
// 		let consecutiveErrors = 0

// 		const startFallbackPolling = () => {
// 			if (fallbackInterval) return
// 			setStreamStatus('fallback')
// 			fallbackInterval = setInterval(() => getLiveLocationRef.current(), 10000)
// 		}

// 		try {
// 			es = new EventSource(url)
// 			setStreamStatus('connecting')

// 			es.addEventListener('live', (event) => {
// 				consecutiveErrors = 0
// 				setStreamStatus('live')
// 				try {
// 					const payload = JSON.parse((event as MessageEvent).data)
// 					if (payload?.success && Array.isArray(payload?.data)) {
// 						setLiveData(payload.data)
// 						setLastUpdatedAt(Date.now())
// 					}
// 				} catch {
// 					// Ignore malformed frame; next one will arrive shortly.
// 				}
// 			})

// 			es.onerror = () => {
// 				consecutiveErrors += 1
// 				setStreamStatus('reconnecting')
// 				// After several consecutive errors, give up on SSE and fall back to
// 				// HTTP polling (e.g. server doesn't support streaming, proxy in the way).
// 				if (consecutiveErrors >= 5) {
// 					es?.close()
// 					startFallbackPolling()
// 				}
// 			}
// 		} catch {
// 			startFallbackPolling()
// 		}

// 		return () => {
// 			es?.close()
// 			if (fallbackInterval) clearInterval(fallbackInterval)
// 		}
// 	}, [jwt?.token])

// 	// Keep the open modal's `selectedMarker` and `focusedVehicle` references
// 	// in sync with the latest SSE frame. Without this, both stay pinned to
// 	// the snapshot from the moment the user clicked, so fields like `time`
// 	// / `speed` / `latitude` never refresh while the modal is open and the
// 	// "Last update" tile would freeze (or show '—' if the original snapshot
// 	// happened to lack the field for any reason).
// 	useEffect(() => {
// 		if (!liveData.length) return
// 		setSelectedMarker((prev: any) => {
// 			if (!prev) return prev
// 			const key = vehicleKey(prev)
// 			if (!key) return prev
// 			const fresh = liveData.find((item) => vehicleKey(item) === key)
// 			return fresh || prev
// 		})
// 		setFocusedVehicle((prev: any) => {
// 			if (!prev) return prev
// 			const key = vehicleKey(prev)
// 			if (!key) return prev
// 			const fresh = liveData.find((item) => vehicleKey(item) === key)
// 			return fresh || prev
// 		})
// 	}, [liveData])

// 	// Tick once a second so the "updated Xs ago" indicator stays accurate
// 	// without re-rendering the rest of the tree on every data frame.
// 	useEffect(() => {
// 		const id = setInterval(() => {
// 			if (lastUpdatedAt) {
// 				setSecondsSinceUpdate(Math.floor((Date.now() - lastUpdatedAt) / 1000))
// 			}
// 		}, 1000)
// 		return () => clearInterval(id)
// 	}, [lastUpdatedAt])

// 	// ESC closes the vehicle detail modal. Body scroll lock prevents the page
// 	// behind the popup from scrolling while a vehicle is selected.
// 	useEffect(() => {
// 		if (!selectedMarker) return
// 		const onKey = (e: KeyboardEvent) => {
// 			if (e.key === 'Escape') setSelectedMarker(null)
// 		}
// 		document.addEventListener('keydown', onKey)
// 		const prevOverflow = document.body.style.overflow
// 		document.body.style.overflow = 'hidden'
// 		return () => {
// 			document.removeEventListener('keydown', onKey)
// 			document.body.style.overflow = prevOverflow
// 		}
// 	}, [selectedMarker])

// 	useEffect(() => {
// 		animatedPositionsRef.current = animatedPositions
// 	}, [animatedPositions])

// 	useEffect(() => {
// 		animatedBearingsRef.current = animatedBearings
// 	}, [animatedBearings])

// 	useEffect(() => {
// 		if (!liveData.length) return
// 		const bearingUpdates: Record<string, number> = {}
// 		setVehicleTracks((prev) => {
// 			const next = { ...prev }
// 			liveData.forEach((item) => {
// 				const key = vehicleKey(item)
// 				if (!key) return
// 				const lat = toNum(item?.latitude, NaN)
// 				const lng = toNum(item?.longitude, NaN)
// 				if (Number.isNaN(lat) || Number.isNaN(lng)) return

// 				const point = {
// 					lat,
// 					lng,
// 					time: item?.time || item?.device_time || item?.datetime || '',
// 				}

// 				const existing = Array.isArray(next[key]) ? next[key] : []
// 				const last = existing[existing.length - 1]
// 				const isSamePoint = last && Math.abs(last.lat - point.lat) < 0.000001 && Math.abs(last.lng - point.lng) < 0.000001
// 				if (isSamePoint) return

// 				// Only update bearing on meaningful movement (~1m+) to avoid GPS jitter spinning the icon.
// 				if (last) {
// 					const movedKm = haversineKm(last.lat, last.lng, point.lat, point.lng)
// 					if (movedKm > 0.001) {
// 						bearingUpdates[key] = getBearingDeg(last.lat, last.lng, point.lat, point.lng)
// 					}
// 				}

// 				next[key] = [...existing, point].slice(-MAX_TRACK_POINTS)
// 			})
// 			return next
// 		})

// 		if (Object.keys(bearingUpdates).length) {
// 			setVehicleBearings((prev) => ({ ...prev, ...bearingUpdates }))
// 		}
// 	}, [liveData])

// 	// Diff each new live frame against the previous one to detect state
// 	// transitions (overspeed, start/stop motion, online/offline, long idle).
// 	// First frame after mount is suppressed so the user isn't spammed with
// 	// "started moving" alerts for vehicles that were already moving on load.
// 	useEffect(() => {
// 		if (!liveData.length) return

// 		const prev = prevDataRef.current
// 		const next: Record<string, any> = {}
// 		const newAlerts: AlertEvent[] = []
// 		const now = Date.now()
// 		const seenKeys = new Set<string>()

// 		liveData.forEach((item) => {
// 			const key = vehicleKey(item)
// 			if (!key) return
// 			seenKeys.add(key)
// 			next[key] = item

// 			if (isFirstFrameRef.current) return

// 			const before = prev[key]
// 			const speedNow = toNum(item?.speed, 0)
// 			const speedBefore = toNum(before?.speed, 0)
// 			const stopSecNow = parseDurationToSec(String(item?.stop_duration || ''))
// 			const stopSecBefore = parseDurationToSec(String(before?.stop_duration || ''))
// 			const trackTimeNow = parseTrackTime(item?.time || item?.device_time || item?.datetime)
// 			const trackTimeBefore = before
// 				? parseTrackTime(before?.time || before?.device_time || before?.datetime)
// 				: NaN
// 			const offlineNow = Number.isFinite(trackTimeNow) ? now - trackTimeNow > OFFLINE_THRESHOLD_MS : false
// 			const offlineBefore = Number.isFinite(trackTimeBefore)
// 				? now - trackTimeBefore > OFFLINE_THRESHOLD_MS
// 				: false
// 			const name = String(item?.name || '-')

// 			if (speedNow > SPEED_LIMIT_KMH && speedBefore <= SPEED_LIMIT_KMH) {
// 				newAlerts.push({
// 					id: `${key}-overspeed-${now}`,
// 					type: 'overspeed',
// 					severity: 'danger',
// 					title: `Overspeed · ${Math.round(speedNow)} km/h`,
// 					vehicle: name,
// 					at: now,
// 				})
// 			}

// 			if (!before) {
// 				// New vehicle appeared in the feed (typically came online).
// 				if (!offlineNow) {
// 					newAlerts.push({
// 						id: `${key}-online-${now}`,
// 						type: 'online',
// 						severity: 'success',
// 						title: 'Came online',
// 						vehicle: name,
// 						at: now,
// 					})
// 				}
// 			} else {
// 				if (speedBefore <= 3 && speedNow > 3) {
// 					newAlerts.push({
// 						id: `${key}-move-${now}`,
// 						type: 'started_moving',
// 						severity: 'info',
// 						title: 'Started moving',
// 						vehicle: name,
// 						at: now,
// 					})
// 				}
// 				if (speedBefore > 3 && speedNow <= 3) {
// 					newAlerts.push({
// 						id: `${key}-stop-${now}`,
// 						type: 'stopped',
// 						severity: 'warning',
// 						title: 'Stopped',
// 						vehicle: name,
// 						at: now,
// 					})
// 				}
// 				if (!offlineBefore && offlineNow) {
// 					newAlerts.push({
// 						id: `${key}-offline-${now}`,
// 						type: 'offline',
// 						severity: 'danger',
// 						title: 'Went offline',
// 						vehicle: name,
// 						at: now,
// 					})
// 				}
// 				if (offlineBefore && !offlineNow) {
// 					newAlerts.push({
// 						id: `${key}-online-${now}`,
// 						type: 'online',
// 						severity: 'success',
// 						title: 'Came online',
// 						vehicle: name,
// 						at: now,
// 					})
// 				}
// 				// Long idle: just crossed the 30-minute threshold this frame.
// 				if (stopSecBefore < 30 * 60 && stopSecNow >= 30 * 60 && speedNow <= 3) {
// 					newAlerts.push({
// 						id: `${key}-idle-${now}`,
// 						type: 'long_idle',
// 						severity: 'warning',
// 						title: `Idle ${Math.floor(stopSecNow / 60)} min`,
// 						vehicle: name,
// 						at: now,
// 					})
// 				}
// 			}
// 		})

// 		// Detect vehicles that disappeared from the feed entirely → went offline.
// 		if (!isFirstFrameRef.current) {
// 			Object.keys(prev).forEach((key) => {
// 				if (seenKeys.has(key)) return
// 				const item = prev[key]
// 				newAlerts.push({
// 					id: `${key}-offline-${now}`,
// 					type: 'offline',
// 					severity: 'danger',
// 					title: 'Went offline',
// 					vehicle: String(item?.name || '-'),
// 					at: now,
// 				})
// 			})
// 		}

// 		prevDataRef.current = next
// 		isFirstFrameRef.current = false

// 		if (newAlerts.length) {
// 			setAlerts((cur) => {
// 				const fresh = cur.filter((a) => now - a.at < ALERT_TTL_MS)
// 				return [...newAlerts, ...fresh].slice(0, MAX_ALERTS)
// 			})
// 		}
// 	}, [liveData])

// 	// Periodically expire alerts older than ALERT_TTL_MS so the strip self-cleans
// 	// even when no new live frames are arriving.
// 	useEffect(() => {
// 		if (!alerts.length) return
// 		const id = setInterval(() => {
// 			const now = Date.now()
// 			setAlerts((cur) => {
// 				const fresh = cur.filter((a) => now - a.at < ALERT_TTL_MS)
// 				return fresh.length === cur.length ? cur : fresh
// 			})
// 		}, 5000)
// 		return () => clearInterval(id)
// 	}, [alerts.length])

// 	// Snap every vehicle's GPS point to the nearest road via Google Roads API,
// 	// so all markers sit on roads instead of off-road from raw GPS drift.
// 	// Results are cached by quantized coordinate to keep request volume / cost low
// 	// (vehicles often report identical points repeatedly when stopped or moving slowly).
// 	useEffect(() => {
// 		if (!liveData.length) return
// 		const apiKey = MAP_API_KEY
// 		if (!apiKey) return

// 		type Pending = { key: string; lat: number; lng: number; cacheKey: string }
// 		const pending: Pending[] = []
// 		const cachedHits: Record<string, { lat: number; lng: number }> = {}

// 		liveData.forEach((item) => {
// 			const key = vehicleKey(item)
// 			const lat = toNum(item?.latitude, NaN)
// 			const lng = toNum(item?.longitude, NaN)
// 			if (!key || Number.isNaN(lat) || Number.isNaN(lng)) return
// 			// 5dp ~= 1.1m bucketing — close enough that GPS jitter hits the same cache slot.
// 			const cacheKey = `${lat.toFixed(5)},${lng.toFixed(5)}`
// 			const cached = snapCacheRef.current.get(cacheKey)
// 			if (cached) {
// 				cachedHits[key] = cached
// 				return
// 			}
// 			pending.push({ key, lat, lng, cacheKey })
// 		})

// 		if (Object.keys(cachedHits).length) {
// 			setSnappedTargets((prev) => ({ ...prev, ...cachedHits }))
// 		}

// 		if (!pending.length) return

// 		const controller = new AbortController()
// 		// Roads API allows up to 100 points per call.
// 		const chunks: Pending[][] = []
// 		for (let i = 0; i < pending.length; i += 100) {
// 			chunks.push(pending.slice(i, i + 100))
// 		}

// 		chunks.forEach((chunk) => {
// 			const points = chunk.map((p) => `${p.lat},${p.lng}`).join('|')
// 			const url =
// 				`https://roads.googleapis.com/v1/nearestRoads?points=${encodeURIComponent(points)}` +
// 				`&key=${apiKey}`
// 			fetch(url, { signal: controller.signal })
// 				.then((r) => r.json())
// 				.then((data) => {
// 					if (!Array.isArray(data?.snappedPoints)) return
// 					const updates: Record<string, { lat: number; lng: number }> = {}
// 					data.snappedPoints.forEach((sp: any) => {
// 						const orig = chunk[sp?.originalIndex ?? -1]
// 						if (!orig) return
// 						const snapped = {
// 							lat: Number(sp?.location?.latitude),
// 							lng: Number(sp?.location?.longitude),
// 						}
// 						if (!Number.isFinite(snapped.lat) || !Number.isFinite(snapped.lng)) return
// 						snapCacheRef.current.set(orig.cacheKey, snapped)
// 						updates[orig.key] = snapped
// 					})
// 					if (Object.keys(updates).length) {
// 						setSnappedTargets((prev) => ({ ...prev, ...updates }))
// 					}
// 				})
// 				.catch(() => {
// 					// Silently ignore (offline, API disabled, quota, etc.) — falls back to raw GPS.
// 				})
// 		})

// 		return () => {
// 			controller.abort()
// 		}
// 	}, [liveData])

// 	useEffect(() => {
// 		if (!liveData.length) return

// 		const startByKey: Record<string, { lat: number; lng: number }> = {}
// 		const endByKey: Record<string, { lat: number; lng: number }> = {}
// 		const startBearingByKey: Record<string, number> = {}
// 		const endBearingByKey: Record<string, number> = {}

// 		liveData.forEach((item) => {
// 			const key = vehicleKey(item)
// 			if (!key) return
// 			const rawLat = toNum(item?.latitude, NaN)
// 			const rawLng = toNum(item?.longitude, NaN)
// 			if (Number.isNaN(rawLat) || Number.isNaN(rawLng)) return

// 			// Prefer road-snapped target if available, else fall back to raw GPS.
// 			const snapped = snappedTargets[key]
// 			const lat = snapped?.lat ?? rawLat
// 			const lng = snapped?.lng ?? rawLng

// 			const fromPos = animatedPositionsRef.current[key] || { lat, lng }
// 			endByKey[key] = { lat, lng }
// 			startByKey[key] = fromPos

// 			// Bearing target: prefer the actual segment from the animated start to the new fix
// 			// (this is what Uber does — rotation matches the segment being travelled).
// 			const movedKm = haversineKm(fromPos.lat, fromPos.lng, lat, lng)
// 			let targetBearing: number | undefined
// 			if (movedKm > 0.001) {
// 				targetBearing = getBearingDeg(fromPos.lat, fromPos.lng, lat, lng)
// 			} else {
// 				targetBearing = animatedBearingsRef.current[key]
// 			}
// 			const currentBearing = animatedBearingsRef.current[key] ?? targetBearing ?? 0
// 			startBearingByKey[key] = currentBearing
// 			endBearingByKey[key] = targetBearing ?? currentBearing
// 		})

// 		if (animationRef.current) {
// 			cancelAnimationFrame(animationRef.current)
// 		}

// 		const durationMs = 1800
// 		const startTime = performance.now()

// 		const tick = (now: number) => {
// 			const progress = Math.min(1, (now - startTime) / durationMs)
// 			const eased = progress < 1 ? 1 - Math.pow(1 - progress, 3) : 1
// 			const nextPos: Record<string, { lat: number; lng: number }> = {}
// 			const nextBearing: Record<string, number> = { ...animatedBearingsRef.current }

// 			Object.keys(endByKey).forEach((key) => {
// 				const from = startByKey[key]
// 				const to = endByKey[key]
// 				nextPos[key] = {
// 					lat: from.lat + (to.lat - from.lat) * eased,
// 					lng: from.lng + (to.lng - from.lng) * eased,
// 				}
// 				nextBearing[key] = lerpAngle(startBearingByKey[key], endBearingByKey[key], eased)
// 			})

// 			setAnimatedPositions(nextPos)
// 			setAnimatedBearings(nextBearing)
// 			if (progress < 1) {
// 				animationRef.current = requestAnimationFrame(tick)
// 			} else {
// 				animationRef.current = null
// 			}
// 		}

// 		animationRef.current = requestAnimationFrame(tick)
// 		return () => {
// 			if (animationRef.current) {
// 				cancelAnimationFrame(animationRef.current)
// 				animationRef.current = null
// 			}
// 		}
// 	}, [liveData, snappedTargets])

// 	const dashboardStats = useMemo(() => {
// 		const totalVehicles = liveData.length
// 		let movingNow = 0
// 		let idle = 0
// 		let stopped = 0
// 		let offline = 0
// 		let movingSpeedSum = 0
// 		let topSpeed = 0
// 		let topSpeedVehicle = ''
// 		let overspeed = 0
// 		const now = Date.now()

// 		liveData.forEach((item) => {
// 			const speed = toNum(item?.speed, 0)
// 			const stopSec = parseDurationToSec(String(item?.stop_duration || ''))
// 			const trackTime = parseTrackTime(item?.time || item?.device_time || item?.datetime)
// 			const isOffline = Number.isFinite(trackTime) ? now - trackTime > 6 * 3600 * 1000 : false

// 			if (isOffline) {
// 				offline += 1
// 				return
// 			}
// 			if (speed > topSpeed) {
// 				topSpeed = speed
// 				topSpeedVehicle = String(item?.name || '')
// 			}
// 			if (speed > SPEED_LIMIT_KMH) overspeed += 1
// 			if (speed > 3) {
// 				movingNow += 1
// 				movingSpeedSum += speed
// 				return
// 			}
// 			if (stopSec > 0 && stopSec <= 30 * 60) {
// 				idle += 1
// 				return
// 			}
// 			stopped += 1
// 		})

// 		const avgSpeed = movingNow > 0 ? Math.round(movingSpeedSum / movingNow) : 0

// 		return {
// 			totalVehicles,
// 			movingNow,
// 			idle,
// 			stopped,
// 			offline,
// 			avgSpeed,
// 			topSpeed: Math.round(topSpeed),
// 			topSpeedVehicle,
// 			overspeed,
// 		}
// 	}, [liveData])

// 	// Capture the map's initial center exactly once, when the first live frame
// 	// arrives. After that, ONLY explicit clicks (mapCenterOverride) or imperative
// 	// panTo / MarkerClusterer interactions move the camera. Re-deriving center
// 	// from `liveData` on every SSE frame fights the user's pan/zoom and snaps
// 	// cluster clicks back to liveData[0] (usually the densest area).
// 	useEffect(() => {
// 		if (initialMapCenter) return
// 		if (!liveData.length) return
// 		const first = liveData[0]
// 		const lat = toNum(first?.latitude, NaN)
// 		const lng = toNum(first?.longitude, NaN)
// 		if (Number.isNaN(lat) || Number.isNaN(lng)) return
// 		setInitialMapCenter({ lat, lng })
// 	}, [liveData, initialMapCenter])

// 	const mapCenter = useMemo(() => {
// 		if (mapCenterOverride) return mapCenterOverride
// 		return initialMapCenter ?? { lat: 23.7806, lng: 90.407 }
// 	}, [mapCenterOverride, initialMapCenter])

// 	const recentActivity = useMemo(() => {
// 		const rows = [...liveData].map((item) => {
// 			const speed = toNum(item?.speed, 0)
// 			const stopSec = parseDurationToSec(String(item?.stop_duration || ''))
// 			const status = speed > 3 ? 'Moving' : stopSec > 30 * 60 ? 'Stopped' : 'Idle'
// 			const timeValue = parseTrackTime(item?.time || item?.device_time || item?.datetime)
// 			const rank = status === 'Moving' ? 0 : status === 'Idle' ? 1 : 2
// 			const key = vehicleKey(item)
// 			const lat = toNum(item?.latitude, NaN)
// 			const lng = toNum(item?.longitude, NaN)
// 			const cacheKey =
// 				!Number.isNaN(lat) && !Number.isNaN(lng) ? `${lat.toFixed(5)},${lng.toFixed(5)}` : ''
// 			const address = cleanAddress(
// 				(key && vehicleAddresses[key]) ||
// 					(cacheKey && addressCache.get(cacheKey)) ||
// 					''
// 			)
// 			return {
// 				key,
// 				vehicle: item,
// 				name: item?.name || '-',
// 				status,
// 				speedText: `${speed} km/h`,
// 				rank,
// 				timeValue: Number.isFinite(timeValue) ? timeValue : 0,
// 				address,
// 			}
// 		})

// 		rows.sort((a, b) => {
// 			if (a.rank !== b.rank) return a.rank - b.rank
// 			return b.timeValue - a.timeValue
// 		})

// 		return rows
// 	}, [liveData, vehicleAddresses])

// 	const selectedTrack = useMemo(() => {
// 		const targetVehicle = focusedVehicle || selectedMarker
// 		if (!targetVehicle) return []
// 		const key = vehicleKey(targetVehicle)
// 		return key ? vehicleTracks[key] || [] : []
// 	}, [focusedVehicle, selectedMarker, vehicleTracks])

// 	useEffect(() => {
// 		if (!mapsReady || !window.google?.maps?.DirectionsService || selectedTrack.length < 2) {
// 			setSnappedSelectedTrack([])
// 			setIsSelectedTrackSnapped(false)
// 			return
// 		}

// 		const sampled = sampleRoutePoints(selectedTrack.map((p) => ({ lat: p.lat, lng: p.lng })))
// 		if (sampled.length < 2) {
// 			setSnappedSelectedTrack([])
// 			setIsSelectedTrackSnapped(false)
// 			return
// 		}

// 		let cancelled = false
// 		const service = new window.google.maps.DirectionsService()
// 		const applyResult = (result: google.maps.DirectionsResult | null, status: google.maps.DirectionsStatus) => {
// 			if (cancelled) return false
// 			const route = result?.routes?.[0]
// 			if (status === 'OK' && route?.overview_path && route.overview_path.length > 1) {
// 				const path = route.overview_path.map((p) => ({ lat: p.lat(), lng: p.lng() }))
// 				setSnappedSelectedTrack(path)
// 				setIsSelectedTrackSnapped(true)
// 				return true
// 			}
// 			return false
// 		}

// 		service.route(
// 			{
// 				origin: sampled[0],
// 				destination: sampled[sampled.length - 1],
// 				waypoints: sampled.slice(1, -1).map((point) => ({ location: point, stopover: false })),
// 				optimizeWaypoints: false,
// 				travelMode: window.google.maps.TravelMode.DRIVING,
// 			},
// 			(result, status) => {
// 				const ok = applyResult(result, status)
// 				if (ok || cancelled) return
// 				// Retry with simpler route if waypoint-heavy route fails.
// 				service.route(
// 					{
// 						origin: sampled[0],
// 						destination: sampled[sampled.length - 1],
// 						travelMode: window.google.maps.TravelMode.DRIVING,
// 					},
// 					(result2, status2) => {
// 						const ok2 = applyResult(result2, status2)
// 						if (!ok2 && !cancelled) {
// 							setSnappedSelectedTrack([])
// 							setIsSelectedTrackSnapped(false)
// 						}
// 					}
// 				)
// 			}
// 		)

// 		return () => {
// 			cancelled = true
// 		}
// 	}, [mapsReady, selectedTrack])

// 	// Reverse-geocode every live vehicle so Recent Activity can show their address.
// 	// Uses the shared addressCache + sequential lookups to stay under Google's quota.
// 	useEffect(() => {
// 		if (!mapsReady || !liveData.length || !window.google?.maps?.Geocoder) return

// 		let cancelled = false
// 		const geocoder = new window.google.maps.Geocoder()

// 		const initial: Record<string, string> = {}
// 		const pending: Array<{ key: string; cacheKey: string; lat: number; lng: number }> = []

// 		liveData.forEach((item) => {
// 			const key = vehicleKey(item)
// 			if (!key) return
// 			const lat = toNum(item?.latitude, NaN)
// 			const lng = toNum(item?.longitude, NaN)
// 			if (Number.isNaN(lat) || Number.isNaN(lng)) return
// 			const cacheKey = `${lat.toFixed(5)},${lng.toFixed(5)}`
// 			const cached = addressCache.get(cacheKey)
// 			if (cached) {
// 				initial[key] = cleanAddress(cached)
// 			} else {
// 				pending.push({ key, cacheKey, lat, lng })
// 			}
// 		})

// 		if (Object.keys(initial).length) {
// 			setVehicleAddresses((prev) => ({ ...prev, ...initial }))
// 		}

// 		let i = 0
// 		const tick = () => {
// 			if (cancelled || i >= pending.length) return
// 			const p = pending[i++]
// 			geocoder.geocode({ location: { lat: p.lat, lng: p.lng } }, (results, status) => {
// 				if (cancelled) return
// 				if (status === 'OK' && results?.[0]?.formatted_address) {
// 					const text = cleanAddress(results[0].formatted_address)
// 					addressCache.set(p.cacheKey, text)
// 					setVehicleAddresses((prev) => ({ ...prev, [p.key]: text }))
// 				}
// 				setTimeout(tick, 220)
// 			})
// 		}
// 		const startTimer = setTimeout(tick, 0)

// 		return () => {
// 			cancelled = true
// 			clearTimeout(startTimer)
// 		}
// 	}, [mapsReady, liveData])

// 	useEffect(() => {
// 		if (!mapsReady || !selectedMarker || !window.google?.maps?.Geocoder) {
// 			setSelectedLocationName('')
// 			return
// 		}
// 		const lat = toNum(selectedMarker?.latitude, NaN)
// 		const lng = toNum(selectedMarker?.longitude, NaN)
// 		if (Number.isNaN(lat) || Number.isNaN(lng)) {
// 			setSelectedLocationName('')
// 			return
// 		}
// 		const key = `${lat.toFixed(5)},${lng.toFixed(5)}`
// 		if (addressCache.has(key)) {
// 			const cached = cleanAddress(addressCache.get(key) || '')
// 			setSelectedLocationName(cached || formatLatLng(lat, lng))
// 			return
// 		}

// 		const fallback = formatLatLng(lat, lng)
// 		setSelectedLocationName('Loading...')
// 		const geocoder = new window.google.maps.Geocoder()
// 		geocoder.geocode({ location: { lat, lng } }, (results, status) => {
// 			if (status === 'OK' && results?.[0]?.formatted_address) {
// 				const text = cleanAddress(results[0].formatted_address)
// 				addressCache.set(key, text)
// 				setSelectedLocationName(text || fallback)
// 				return
// 			}
// 			setSelectedLocationName(fallback)
// 		})
// 	}, [mapsReady, selectedMarker])

// 	// Pan + zoom on initial selection (or when the user picks a *different*
// 	// vehicle). The dep is the vehicle KEY (string id), not the object — so
// 	// SSE-driven re-syncs of the same vehicle don't re-fire this effect, and
// 	// the user's manual zoom adjustments aren't undone every ~3s. The
// 	// follow-effect below handles tracking the moving vehicle's position
// 	// without changing the zoom.
// 	const focusKeyForPan =
// 		(focusedVehicle ? vehicleKey(focusedVehicle) : '') ||
// 		(selectedMarker ? vehicleKey(selectedMarker) : '')
// 	useEffect(() => {
// 		if (!focusKeyForPan || !mapRef.current) return
// 		const targetVehicle = focusedVehicle || selectedMarker
// 		if (!targetVehicle) return
// 		const lat = toNum(targetVehicle?.latitude, NaN)
// 		const lng = toNum(targetVehicle?.longitude, NaN)
// 		if (Number.isNaN(lat) || Number.isNaN(lng)) return
// 		mapRef.current.panTo({ lat, lng })
// 		// Only push the zoom up when the user is currently more zoomed-out
// 		// than 15 — never clamp them back down if they've zoomed further in.
// 		const currentZoom = mapRef.current.getZoom?.() ?? 0
// 		if (currentZoom < 15) mapRef.current.setZoom(15)
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	}, [focusKeyForPan])

// 	useEffect(() => {
// 		const targetVehicle = focusedVehicle || selectedMarker
// 		if (!targetVehicle || !mapRef.current) return
// 		const key = vehicleKey(targetVehicle)
// 		if (!key) return
// 		const pos = animatedPositions[key]
// 		if (!pos) return
// 		// Keep camera following selected vehicle while it animates.
// 		mapRef.current.panTo({ lat: pos.lat, lng: pos.lng })
// 	}, [animatedPositions, focusedVehicle, selectedMarker])

// 	const selectedTrackDistanceKm = useMemo(() => {
// 		if (selectedTrack.length < 2) return 0
// 		let total = 0
// 		for (let i = 1; i < selectedTrack.length; i += 1) {
// 			const prev = selectedTrack[i - 1]
// 			const curr = selectedTrack[i]
// 			total += haversineKm(prev.lat, prev.lng, curr.lat, curr.lng)
// 		}
// 		return total
// 	}, [selectedTrack])

// 	useEffect(() => {
// 		displayedDistanceRef.current = displayDistanceKm
// 	}, [displayDistanceKm])

// 	// Same distance tween behavior as DetailsVehicle Track tab: ease-out count-up
// 	// over ~700ms so route-distance updates feel smooth instead of jumpy.
// 	useEffect(() => {
// 		const targetVehicle = focusedVehicle || selectedMarker
// 		if (!targetVehicle) {
// 			if (distanceAnimationRef.current) cancelAnimationFrame(distanceAnimationRef.current)
// 			distanceAnimationRef.current = null
// 			displayedDistanceRef.current = 0
// 			setDisplayDistanceKm(0)
// 			return
// 		}

// 		const start = displayedDistanceRef.current
// 		const end = selectedTrackDistanceKm
// 		if (!Number.isFinite(start) || !Number.isFinite(end) || Math.abs(end - start) < 0.0005) {
// 			displayedDistanceRef.current = end
// 			setDisplayDistanceKm(end)
// 			return
// 		}

// 		if (distanceAnimationRef.current) cancelAnimationFrame(distanceAnimationRef.current)
// 		const startedAt = performance.now()
// 		const durationMs = 700

// 		const tick = (now: number) => {
// 			const p = Math.min(1, (now - startedAt) / durationMs)
// 			const eased = 1 - Math.pow(1 - p, 3)
// 			const next = start + (end - start) * eased
// 			displayedDistanceRef.current = next
// 			setDisplayDistanceKm(next)
// 			if (p < 1) {
// 				distanceAnimationRef.current = requestAnimationFrame(tick)
// 			} else {
// 				distanceAnimationRef.current = null
// 			}
// 		}
// 		distanceAnimationRef.current = requestAnimationFrame(tick)

// 		return () => {
// 			if (distanceAnimationRef.current) {
// 				cancelAnimationFrame(distanceAnimationRef.current)
// 				distanceAnimationRef.current = null
// 			}
// 		}
// 	}, [selectedTrackDistanceKm, focusedVehicle, selectedMarker])

// 	// Stable google.maps.Size / Point — created once after maps are loaded.
// 	const iconSize = useMemo(
// 		() => (mapsReady && window.google?.maps?.Size ? new window.google.maps.Size(44, 44) : undefined),
// 		[mapsReady]
// 	)
// 	const iconAnchor = useMemo(
// 		() => (mapsReady && window.google?.maps?.Point ? new window.google.maps.Point(22, 22) : undefined),
// 		[mapsReady]
// 	)
// 	// Bigger size + offset anchor for the selected marker (matches the 64×64
// 	// halo SVG built in `buildCarIconUrl(... isSelected=true)`).
// 	const iconSizeSelected = useMemo(
// 		() => (mapsReady && window.google?.maps?.Size ? new window.google.maps.Size(64, 64) : undefined),
// 		[mapsReady]
// 	)
// 	const iconAnchorSelected = useMemo(
// 		() => (mapsReady && window.google?.maps?.Point ? new window.google.maps.Point(32, 32) : undefined),
// 		[mapsReady]
// 	)

// 	// Stable click handler so React.memo on VehicleMarker isn't busted every render.
// 	// Also pins mapCenterOverride so the next SSE frame doesn't recenter the camera
// 	// onto liveData[0] (which is usually inside the densest cluster).
// 	const handleMarkerClick = useCallback((item: any) => {
// 		const lat = toNum(item?.latitude, NaN)
// 		const lng = toNum(item?.longitude, NaN)
// 		if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
// 			setMapCenterOverride({ lat, lng })
// 		}
// 		setFocusedVehicle(item)
// 		setSelectedMarker(item)
// 	}, [])

// 	// Hoisted out of the render loop — only changes when selection changes.
// 	const focusedKey = useMemo(() => (focusedVehicle ? vehicleKey(focusedVehicle) : null), [focusedVehicle])
// 	const selectedKey = useMemo(() => (selectedMarker ? vehicleKey(selectedMarker) : null), [selectedMarker])

// 	// Snap-to-road tip and bearing for the focused vehicle, computed once per snap update.
// 	const snapTip = useMemo(() => {
// 		if (snappedSelectedTrack.length < 2) return null
// 		return snappedSelectedTrack[snappedSelectedTrack.length - 1]
// 	}, [snappedSelectedTrack])
// 	const snapTipBearing = useMemo(() => {
// 		if (snappedSelectedTrack.length < 2) return null
// 		const tip = snappedSelectedTrack[snappedSelectedTrack.length - 1]
// 		const before = snappedSelectedTrack[snappedSelectedTrack.length - 2]
// 		return getBearingDeg(before.lat, before.lng, tip.lat, tip.lng)
// 	}, [snappedSelectedTrack])

// 	return (
// 		<>
// 			<PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
// 			<div className='row g-3 mb-3'>
// 				<div className='col-6 col-md-4 col-xl'>
// 					<div className='card h-100'>
// 						<div className='card-body py-4'>
// 							<div className='small text-uppercase text-muted'>Total vehicles</div>
// 							<div className='fs-2 fw-bolder'>{dashboardStats.totalVehicles}</div>
// 							<div className='small text-muted'>Active in fleet</div>
// 						</div>
// 					</div>
// 				</div>
// 				<div className='col-6 col-md-4 col-xl'>
// 					<div className='card h-100'>
// 						<div className='card-body py-4'>
// 							<div className='small text-uppercase text-muted'>Moving now</div>
// 							<div className='fs-2 fw-bolder text-success'>{dashboardStats.movingNow}</div>
// 							<div className='small text-muted'>Currently in motion</div>
// 						</div>
// 					</div>
// 				</div>
// 				<div className='col-6 col-md-4 col-xl'>
// 					<div className='card h-100'>
// 						<div className='card-body py-4'>
// 							<div className='small text-uppercase text-muted'>Idle</div>
// 							<div className='fs-2 fw-bolder text-warning'>{dashboardStats.idle}</div>
// 							<div className='small text-muted'>Engine on, not moving</div>
// 						</div>
// 					</div>
// 				</div>
// 				<div className='col-6 col-md-4 col-xl'>
// 					<div className='card h-100'>
// 						<div className='card-body py-4'>
// 							<div className='small text-uppercase text-muted'>Stopped</div>
// 							<div className='fs-2 fw-bolder text-danger'>{dashboardStats.stopped}</div>
// 							<div className='small text-muted'>Parked / engine off</div>
// 						</div>
// 					</div>
// 				</div>
// 				<div className='col-6 col-md-4 col-xl'>
// 					<div className='card h-100'>
// 						<div className='card-body py-4'>
// 							<div className='small text-uppercase text-muted'>Avg speed</div>
// 							<div className='fs-2 fw-bolder text-info'>
// 								{dashboardStats.avgSpeed}
// 								<span className='fs-6 fw-normal text-muted ms-1'>km/h</span>
// 							</div>
// 							<div className='small text-muted'>Across moving vehicles</div>
// 						</div>
// 					</div>
// 				</div>
// 				<div className='col-6 col-md-4 col-xl'>
// 					<div className='card h-100'>
// 						<div className='card-body py-4'>
// 							<div className='small text-uppercase text-muted'>Top speed</div>
// 							<div className='fs-2 fw-bolder text-primary'>
// 								{dashboardStats.topSpeed}
// 								<span className='fs-6 fw-normal text-muted ms-1'>km/h</span>
// 							</div>
// 							<div className='small text-muted text-truncate'>
// 								{dashboardStats.topSpeedVehicle || 'No active vehicle'}
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 				<div className='col-6 col-md-4 col-xl'>
// 					<div className='card h-100'>
// 						<div className='card-body py-4'>
// 							<div className='small text-uppercase text-muted'>Overspeed</div>
// 							<div className={`fs-2 fw-bolder ${dashboardStats.overspeed > 0 ? 'text-danger' : 'text-muted'}`}>
// 								{dashboardStats.overspeed}
// 							</div>
// 							<div className='small text-muted'>Above {SPEED_LIMIT_KMH} km/h</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>

// 			{alerts.length > 0 && (
// 				<div className='card mb-3'>
// 					<div className='card-body py-2 px-3'>
// 						<div className='d-flex align-items-center'>
// 							<span className='badge badge-light-danger me-2 flex-shrink-0'>Live alerts</span>
// 							<div
// 								className='d-flex flex-nowrap gap-2 overflow-auto'
// 								style={{ scrollbarWidth: 'thin' }}
// 							>
// 								{alerts.map((alert) => (
// 									<button
// 										key={alert.id}
// 										type='button'
// 										onClick={() => {
// 											const match = liveData.find(
// 												(item) => String(item?.name || '') === alert.vehicle
// 											)
// 											if (match) {
// 												const lat = toNum(match?.latitude, NaN)
// 												const lng = toNum(match?.longitude, NaN)
// 												if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
// 													setMapCenterOverride({ lat, lng })
// 												}
// 												setFocusedVehicle(match)
// 												setSelectedMarker(match)
// 											}
// 										}}
// 										className={`badge badge-light-${alert.severity} border-0 d-inline-flex align-items-center flex-shrink-0`}
// 										style={{ cursor: 'pointer', padding: '0.5rem 0.75rem' }}
// 										title={new Date(alert.at).toLocaleTimeString()}
// 									>
// 										<span className='fw-bold me-1'>{alert.vehicle}</span>
// 										<span className='me-2'>· {alert.title}</span>
// 										<span className='text-muted small'>
// 											{Math.max(0, Math.floor((Date.now() - alert.at) / 1000))}s
// 										</span>
// 									</button>
// 								))}
// 							</div>
// 							<button
// 								type='button'
// 								className='btn btn-sm btn-light ms-2 flex-shrink-0'
// 								onClick={() => setAlerts([])}
// 							>
// 								Clear
// 							</button>
// 						</div>
// 					</div>
// 				</div>
// 			)}

// 			<div className='row g-3'>
// 				<div className='col-xl-9'>
// 					<div className='card'>
// 						<div className='card-header border-0 pt-4'>
// 							<div>
// 								<h3 className='card-title fw-bolder'>Fleet Tracker</h3>
// 								<div className='small text-muted mt-2'>
// 									Live positions across Bangladesh ·{' '}
// 									{streamStatus === 'live' && 'streaming in real-time'}
// 									{streamStatus === 'connecting' && 'connecting to live stream…'}
// 									{streamStatus === 'reconnecting' && 'reconnecting to live stream…'}
// 									{streamStatus === 'fallback' && 'updated every 10s (fallback mode)'}
// 								</div>
// 							</div>
// 							<div className='card-toolbar d-flex align-items-center gap-2'>
// 								{lastUpdatedAt && (
// 									<span
// 										className={`badge ${
// 											secondsSinceUpdate > 30
// 												? 'badge-light-danger'
// 												: secondsSinceUpdate > 15
// 												? 'badge-light-warning'
// 												: 'badge-light-success'
// 										}`}
// 									>
// 										updated {secondsSinceUpdate}s ago
// 									</span>
// 								)}
// 								<span
// 									className={`badge ${
// 										streamStatus === 'live'
// 											? 'badge-light-success'
// 											: streamStatus === 'fallback'
// 											? 'badge-light-warning'
// 											: 'badge-light-primary'
// 									}`}
// 								>
// 									{streamStatus === 'live' && (isLoading ? 'Refreshing…' : 'Live')}
// 									{streamStatus === 'connecting' && 'Connecting…'}
// 									{streamStatus === 'reconnecting' && 'Reconnecting…'}
// 									{streamStatus === 'fallback' && 'Polling'}
// 								</span>
// 							</div>
// 						</div>
// 						<div className='card-body pt-0'>
// 							<LoadScript googleMapsApiKey={MAP_API_KEY} onLoad={() => setMapsReady(true)}>
// 								<GoogleMap
// 									zoom={8}
// 									mapContainerStyle={{ height: '520px', width: '100%' }}
// 									center={mapCenter}
// 									onLoad={(map) => {
// 										mapRef.current = map
// 									}}
// 								>
// 									{(focusedVehicle || selectedMarker) && snappedSelectedTrack.length > 1 && (
// 										<Polyline
// 											path={snappedSelectedTrack.map((p) => ({
// 												lat: p.lat,
// 												lng: p.lng,
// 											}))}
// 											options={{
// 												strokeColor: '#198754',
// 												strokeOpacity: 0.95,
// 												strokeWeight: 4,
// 											}}
// 										/>
// 									)}

// 									<MarkerClusterer
// 										options={{
// 											gridSize: 60,
// 											maxZoom: 14,
// 											averageCenter: true,
// 											// Show count bubbles for single vehicles as well when
// 											// zoomed out (requested UX).
// 											minimumClusterSize: 1,
// 										}}
// 										onClick={() => {
// 											// On a real cluster click (2+ markers), drop the
// 											// previously-focused vehicle so the animatedPositions
// 											// follow effect doesn't pan back to it while the
// 											// clusterer expands the clicked group.
// 											setFocusedVehicle(null)
// 											setSelectedMarker(null)
// 										}}
// 									>
// 										{(clusterer) => (
// 											<>
// 												{liveData.map((item, index) => {
// 													const key = vehicleKey(item)
// 													const speed = toNum(item?.speed, 0)
// 													const animatedPos = key ? animatedPositions[key] : undefined
// 													const isFocusedVehicle = !!key && (key === focusedKey || key === selectedKey)
// 													const useSnapTip = isFocusedVehicle && !!snapTip

// 													const lat = useSnapTip
// 														? (snapTip as { lat: number; lng: number }).lat
// 														: animatedPos?.lat ?? toNum(item?.latitude, mapCenter.lat)
// 													const lng = useSnapTip
// 														? (snapTip as { lat: number; lng: number }).lng
// 														: animatedPos?.lng ?? toNum(item?.longitude, mapCenter.lng)

// 													const bearing =
// 														(useSnapTip ? snapTipBearing : null) ??
// 														(key ? animatedBearings[key] : undefined) ??
// 														(key ? vehicleBearings[key] : undefined) ??
// 														0

// 													return (
// 														<VehicleMarker
// 															key={`${item?.name || 'car'}-${index}`}
// 															item={item}
// 															lat={lat}
// 															lng={lng}
// 															bearing={bearing}
// 															isMoving={speed > 3}
// 															isSelected={isFocusedVehicle}
// 															iconSize={iconSize}
// 															iconAnchor={iconAnchor}
// 															iconSizeSelected={iconSizeSelected}
// 															iconAnchorSelected={iconAnchorSelected}
// 															onClick={handleMarkerClick}
// 															clusterer={clusterer}
// 														/>
// 													)
// 												})}
// 											</>
// 										)}
// 									</MarkerClusterer>
// 									{/* Vehicle detail modal: rendered into document.body via portal so it
// 									    sits on top of every other page element (header, sidebar, etc.) — not
// 									    just on top of the map overlays the way an InfoWindow does. */}
// 									{selectedMarker && (() => {
// 										const sm = selectedMarker
// 										const sKey = vehicleKey(sm)
// 										const speedNow = toNum(sm?.speed, 0)
// 										const stopSec = parseDurationToSec(String(sm?.stop_duration || ''))
// 										// The upstream payload uses a few different field names depending
// 										// on the device firmware / API version — try them all and fall back
// 										// to whichever one is non-empty so we never silently render a blank.
// 										const lastFixIso =
// 											sm?.time ||
// 											sm?.device_time ||
// 											sm?.datetime ||
// 											sm?.last_seen ||
// 											sm?.last_update ||
// 											sm?.updated_at ||
// 											sm?.track_time ||
// 											sm?.event_time ||
// 											sm?.gps_time ||
// 											''
// 										const lastFixMs = parseTrackTime(lastFixIso)
// 										const ageMs = Number.isFinite(lastFixMs) ? Date.now() - lastFixMs : NaN
// 										const lastUpdateText = Number.isFinite(ageMs)
// 											? formatRelativeTime(ageMs)
// 											: lastFixIso
// 											? String(lastFixIso)
// 											: '—'
// 										const isOffline = Number.isFinite(ageMs) && ageMs > OFFLINE_THRESHOLD_MS
// 										type StatusTone = { label: string; color: string; soft: string; gradient: string }
// 										let status: StatusTone
// 										if (isOffline)
// 											status = {
// 												label: 'Offline',
// 												color: '#475569',
// 												soft: '#e2e8f0',
// 												gradient: 'linear-gradient(135deg, #64748b 0%, #334155 100%)',
// 											}
// 										else if (speedNow > SPEED_LIMIT_KMH)
// 											status = {
// 												label: 'Overspeed',
// 												color: '#dc2626',
// 												soft: '#fee2e2',
// 												gradient: 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
// 											}
// 										else if (speedNow > 3)
// 											status = {
// 												label: 'Moving',
// 												color: '#16a34a',
// 												soft: '#dcfce7',
// 												gradient: 'linear-gradient(135deg, #22c55e 0%, #15803d 100%)',
// 											}
// 										else if (stopSec > 30 * 60)
// 											status = {
// 												label: 'Stopped',
// 												color: '#dc2626',
// 												soft: '#fee2e2',
// 												gradient: 'linear-gradient(135deg, #f87171 0%, #b91c1c 100%)',
// 											}
// 										else
// 											status = {
// 												label: 'Idle',
// 												color: '#d97706',
// 												soft: '#fef3c7',
// 												gradient: 'linear-gradient(135deg, #f59e0b 0%, #b45309 100%)',
// 											}
// 										const heading = (sKey ? animatedBearings[sKey] : undefined) ?? (sKey ? vehicleBearings[sKey] : undefined) ?? 0
// 										const cardinal = bearingToCardinal(heading)
// 										const trackPoints = sKey ? (vehicleTracks[sKey]?.length || 0) : 0
// 										const lat = toNum(sm?.latitude, NaN)
// 										const lng = toNum(sm?.longitude, NaN)
// 										const coords = !Number.isNaN(lat) && !Number.isNaN(lng) ? formatLatLng(lat, lng) : '—'
// 										const speedRatio = Math.min(1, Math.max(0, speedNow / Math.max(SPEED_LIMIT_KMH, 1)))
// 										const detailHref = sm?.id ? `/vehicleDetails/${sm.id}` : null

// 										const StatTile: FC<{
// 											icon: React.ReactNode
// 											label: string
// 											children: React.ReactNode
// 											title?: string
// 											accent: string
// 											accentSoft: string
// 										}> = ({ icon, label, children, title, accent, accentSoft }) => (
// 											<div
// 												title={title}
// 												style={{
// 													display: 'flex',
// 													alignItems: 'center',
// 													gap: 8,
// 													padding: '6px 8px',
// 													borderRadius: 8,
// 													background: '#fff',
// 													border: '1px solid #eef0f3',
// 												}}
// 											>
// 												<div
// 													style={{
// 														flex: '0 0 26px',
// 														height: 26,
// 														width: 26,
// 														borderRadius: 7,
// 														background: accentSoft,
// 														display: 'flex',
// 														alignItems: 'center',
// 														justifyContent: 'center',
// 														color: accent,
// 													}}
// 												>
// 													{icon}
// 												</div>
// 												<div style={{ minWidth: 0, flex: 1 }}>
// 													<div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>
// 														{label}
// 													</div>
// 													<div className='text-truncate' style={{ fontSize: 12, color: '#0f172a', fontWeight: 700, lineHeight: 1.2 }}>
// 														{children}
// 													</div>
// 												</div>
// 											</div>
// 										)

// 										const iconClock = (
// 											<svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
// 												<circle cx='12' cy='12' r='9' />
// 												<path d='M12 7v5l3 2' />
// 											</svg>
// 										)
// 										const iconPause = (
// 											<svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
// 												<rect x='6' y='5' width='4' height='14' rx='1' />
// 												<rect x='14' y='5' width='4' height='14' rx='1' />
// 											</svg>
// 										)
// 										const iconCompass = (
// 											<svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={{ transform: `rotate(${heading}deg)`, transition: 'transform 400ms ease' }}>
// 												<circle cx='12' cy='12' r='9' />
// 												<path d='M12 4 L14 12 L12 11 L10 12 Z' fill='currentColor' />
// 											</svg>
// 										)
// 										const iconRoute = (
// 											<svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
// 												<circle cx='6' cy='6' r='2' />
// 												<circle cx='18' cy='18' r='2' />
// 												<path d='M6 8 V14 a4 4 0 0 0 4 4 H16' />
// 											</svg>
// 										)
// 										const iconPin = (
// 											<svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
// 												<path d='M12 22s7-7.58 7-13a7 7 0 0 0-14 0c0 5.42 7 13 7 13Z' />
// 												<circle cx='12' cy='9' r='2.5' />
// 											</svg>
// 										)
// 										const iconArrow = (
// 											<svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
// 												<path d='M5 12h14M13 6l6 6-6 6' />
// 											</svg>
// 										)

// 										const iconClose = (
// 											<svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round'>
// 												<path d='M6 6l12 12M18 6l-12 12' />
// 											</svg>
// 										)
// 										const iconCar = (
// 											<svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
// 												<path d='M3 13l2-5a2 2 0 0 1 2-1.4h10a2 2 0 0 1 2 1.4l2 5' />
// 												<path d='M3 13h18v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4z' fill='currentColor' fillOpacity='0.18' />
// 												<circle cx='7.5' cy='15.5' r='1.4' fill='currentColor' />
// 												<circle cx='16.5' cy='15.5' r='1.4' fill='currentColor' />
// 												<path d='M6 13l1-3.5h10L18 13' opacity='0.6' />
// 											</svg>
// 										)

// 										const modal = (
// 											<div
// 												onClick={() => setSelectedMarker(null)}
// 												style={{
// 													position: 'fixed',
// 													inset: 0,
// 													background: 'rgba(15, 23, 42, 0.55)',
// 													backdropFilter: 'blur(2px)',
// 													WebkitBackdropFilter: 'blur(2px)',
// 													zIndex: 100000,
// 													display: 'flex',
// 													alignItems: 'center',
// 													justifyContent: 'center',
// 													padding: 16,
// 													animation: 'lcm-fade-in 160ms ease-out',
// 												}}
// 											>
// 												<style>{`
// 													@keyframes lcm-fade-in { from { opacity: 0 } to { opacity: 1 } }
// 													@keyframes lcm-pop-in { from { opacity: 0; transform: translateY(8px) scale(0.98) } to { opacity: 1; transform: translateY(0) scale(1) } }
// 												`}</style>
// 												<div
// 													onClick={(e) => e.stopPropagation()}
// 													style={{
// 														width: 340,
// 														maxWidth: '100%',
// 														fontFamily: 'inherit',
// 														color: '#0f172a',
// 														borderRadius: 14,
// 														overflow: 'hidden',
// 														background: '#fff',
// 														boxShadow: '0 20px 48px rgba(15,23,42,0.28), 0 4px 12px rgba(15,23,42,0.18)',
// 														animation: 'lcm-pop-in 200ms ease-out',
// 														position: 'relative',
// 														zIndex: 1,
// 													}}
// 												>
// 													<div
// 														style={{
// 															background: status.gradient,
// 															color: '#fff',
// 															padding: '14px 14px 16px',
// 															position: 'relative',
// 														}}
// 													>
// 														<div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
// 															<div
// 																style={{
// 																	flex: '0 0 44px',
// 																	height: 44,
// 																	width: 44,
// 																	borderRadius: 11,
// 																	background: 'rgba(255,255,255,0.22)',
// 																	display: 'flex',
// 																	alignItems: 'center',
// 																	justifyContent: 'center',
// 																	color: '#fff',
// 																}}
// 															>
// 																{iconCar}
// 															</div>
// 															<div style={{ minWidth: 0, flex: 1, paddingRight: 32 }}>
// 																<div
// 																	style={{
// 																		fontSize: 20,
// 																		fontWeight: 800,
// 																		lineHeight: 1.15,
// 																		wordBreak: 'break-word',
// 																		letterSpacing: 0.2,
// 																	}}
// 																	title={sm?.name || '-'}
// 																>
// 																	{sm?.name || '-'}
// 																</div>
// 																{sm?.device_name && (
// 																	<div
// 																		style={{
// 																			fontSize: 12,
// 																			opacity: 0.9,
// 																			marginTop: 3,
// 																			wordBreak: 'break-word',
// 																		}}
// 																		title={sm.device_name}
// 																	>
// 																		{sm.device_name}
// 																	</div>
// 																)}
// 																<span
// 																	style={{
// 																		display: 'inline-block',
// 																		marginTop: 8,
// 																		background: 'rgba(255,255,255,0.95)',
// 																		color: status.color,
// 																		fontSize: 11,
// 																		fontWeight: 800,
// 																		padding: '4px 10px',
// 																		borderRadius: 999,
// 																		letterSpacing: 0.5,
// 																		textTransform: 'uppercase',
// 																	}}
// 																>
// 																	{status.label}
// 																</span>
// 															</div>
// 														</div>
// 														<button
// 															type='button'
// 															onClick={() => setSelectedMarker(null)}
// 															aria-label='Close'
// 															style={{
// 																position: 'absolute',
// 																top: 10,
// 																right: 10,
// 																height: 28,
// 																width: 28,
// 																borderRadius: 8,
// 																background: 'rgba(255,255,255,0.22)',
// 																color: '#fff',
// 																border: 'none',
// 																cursor: 'pointer',
// 																display: 'flex',
// 																alignItems: 'center',
// 																justifyContent: 'center',
// 															}}
// 														>
// 															{iconClose}
// 														</button>
// 													</div>

// 													<div style={{ padding: '12px 12px 12px' }}>
// 														<div
// 															style={{
// 																display: 'flex',
// 																alignItems: 'center',
// 																gap: 10,
// 																padding: '8px 10px',
// 																background: status.soft,
// 																borderRadius: 10,
// 															}}
// 														>
// 															<div style={{ display: 'flex', alignItems: 'baseline', gap: 3 }}>
// 																<span
// 																	style={{
// 																		fontSize: 30,
// 																		fontWeight: 800,
// 																		lineHeight: 1,
// 																		color: status.color,
// 																	}}
// 																>
// 																	{Math.round(speedNow)}
// 																</span>
// 																<span style={{ fontSize: 11, color: status.color, fontWeight: 700, opacity: 0.8 }}>
// 																	km/h
// 																</span>
// 															</div>
// 															<div style={{ flex: 1 }}>
// 																<div
// 																	style={{
// 																		height: 6,
// 																		background: 'rgba(255,255,255,0.7)',
// 																		borderRadius: 999,
// 																		overflow: 'hidden',
// 																	}}
// 																>
// 																	<div
// 																		style={{
// 																			height: '100%',
// 																			width: `${speedRatio * 100}%`,
// 																			background: status.color,
// 																			borderRadius: 999,
// 																			transition: 'width 600ms ease',
// 																		}}
// 																	/>
// 																</div>
// 																<div
// 																	style={{
// 																		display: 'flex',
// 																		justifyContent: 'space-between',
// 																		fontSize: 9,
// 																		color: status.color,
// 																		opacity: 0.75,
// 																		marginTop: 3,
// 																		fontWeight: 600,
// 																	}}
// 																>
// 																	<span>0</span>
// 																	<span>LIMIT {SPEED_LIMIT_KMH}</span>
// 																</div>
// 															</div>
// 														</div>

// 														<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginTop: 10 }}>
// 															<StatTile
// 																icon={iconClock}
// 																label='Last update'
// 																title={lastFixIso || ''}
// 																accent='#2563eb'
// 																accentSoft='#dbeafe'
// 															>
// 																{lastUpdateText}
// 															</StatTile>
// 															<StatTile
// 																icon={iconPause}
// 																label='Stopped'
// 																accent='#d97706'
// 																accentSoft='#fef3c7'
// 															>
// 																{sm?.stop_duration || (stopSec > 0 ? formatDurationSec(stopSec) : '—')}
// 															</StatTile>
// 															<StatTile
// 																icon={iconCompass}
// 																label='Heading'
// 																accent='#7c3aed'
// 																accentSoft='#ede9fe'
// 															>
// 																{cardinal}
// 																<span style={{ fontWeight: 600, color: '#64748b', marginLeft: 4 }}>
// 																	{Math.round(heading)}°
// 																</span>
// 															</StatTile>
// 															<StatTile
// 																icon={iconRoute}
// 																label='Distance'
// 																accent='#0ea5e9'
// 																accentSoft='#e0f2fe'
// 																title={`${trackPoints} track points${isSelectedTrackSnapped ? ' · snapped to road' : ''}`}
// 															>
// 																{displayDistanceKm.toFixed(1)} km
// 																{selectedTrack.length < 2 && (
// 																	<span style={{ fontWeight: 500, color: '#94a3b8', marginLeft: 3, fontSize: 10 }}>
// 																		(…)
// 																	</span>
// 																)}
// 															</StatTile>
// 														</div>

// 														<div
// 															style={{
// 																display: 'flex',
// 																alignItems: 'flex-start',
// 																gap: 8,
// 																marginTop: 10,
// 																padding: '8px 10px',
// 																borderRadius: 10,
// 																background: '#f8fafc',
// 																border: '1px solid #eef0f3',
// 															}}
// 															title={selectedLocationName || coords}
// 														>
// 															<div
// 																style={{
// 																	flex: '0 0 22px',
// 																	height: 22,
// 																	width: 22,
// 																	borderRadius: 6,
// 																	background: status.soft,
// 																	color: status.color,
// 																	display: 'flex',
// 																	alignItems: 'center',
// 																	justifyContent: 'center',
// 																}}
// 															>
// 																{iconPin}
// 															</div>
// 															<div style={{ minWidth: 0, flex: 1 }}>
// 																<div
// 																	style={{
// 																		fontSize: 12,
// 																		fontWeight: 700,
// 																		color: '#0f172a',
// 																		lineHeight: 1.3,
// 																		display: '-webkit-box',
// 																		WebkitLineClamp: 2,
// 																		WebkitBoxOrient: 'vertical',
// 																		overflow: 'hidden',
// 																	}}
// 																>
// 																	{selectedLocationName || coords}
// 																</div>
// 																<div style={{ fontSize: 10, color: '#94a3b8', marginTop: 1, fontWeight: 500 }}>
// 																	{coords}
// 																</div>
// 															</div>
// 														</div>

// 														{detailHref && (
// 															<div style={{ marginTop: 10 }}>
// 																<a
// 																	href={`#${detailHref}`}
// 																	style={{
// 																		display: 'inline-flex',
// 																		width: '100%',
// 																		alignItems: 'center',
// 																		justifyContent: 'center',
// 																		gap: 6,
// 																		fontSize: 12,
// 																		fontWeight: 700,
// 																		padding: '9px 12px',
// 																		borderRadius: 8,
// 																		background: status.gradient,
// 																		color: '#fff',
// 																		textDecoration: 'none',
// 																		boxShadow: `0 2px 6px ${status.color}55`,
// 																	}}
// 																>
// 																	<span>View details</span>
// 																	{iconArrow}
// 																</a>
// 															</div>
// 														)}
// 													</div>
// 												</div>
// 											</div>
// 										)

// 										return createPortal(modal, document.body)
// 									})()}
// 								</GoogleMap>
// 							</LoadScript>
// 						</div>
// 					</div>
// 				</div>

// 				<div className='col-xl-3'>
// 					<div className='card'>
// 						<div className='card-header py-3'>
// 							<h4 className='card-title fw-bold'>Recent Activity</h4>
// 						</div>
// 						<div className='card-body py-2' style={{ maxHeight: '500px', overflowY: 'auto' }}>
// 							{recentActivity.length > 0 ? (
// 								recentActivity.map((row, index) => {
// 									const rowKey = row.key
// 									const isRowSelected = !!rowKey && (rowKey === focusedKey || rowKey === selectedKey)
// 									return (
// 									<div
// 										key={`${row.name}-${index}`}
// 										className='border-bottom py-2'
// 										style={{
// 											cursor: 'pointer',
// 											background: isRowSelected ? 'rgba(37, 99, 235, 0.08)' : undefined,
// 											borderLeft: isRowSelected
// 												? `3px solid ${SELECTION_HIGHLIGHT_COLOR}`
// 												: '3px solid transparent',
// 											paddingLeft: 8,
// 											transition: 'background 150ms ease',
// 										}}
// 										onClick={() => {
// 											const lat = toNum(row?.vehicle?.latitude, NaN)
// 											const lng = toNum(row?.vehicle?.longitude, NaN)
// 											if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
// 												setMapCenterOverride({ lat, lng })
// 											}
// 											setFocusedVehicle(row.vehicle)
// 											// Recent Activity click should only focus/highlight on map.
// 											// Modal remains map-marker driven per UX request.
// 											setSelectedMarker(null)
// 										}}
// 									>
// 										<div className='d-flex justify-content-between align-items-center'>
// 											<div>
// 												<span className={`badge me-2 ${row.status === 'Moving' ? 'badge-light-success' : row.status === 'Stopped' ? 'badge-light-danger' : 'badge-light-warning'}`}>
// 													{row.status}
// 												</span>
// 												<span className='small fw-bold'>{row.name}</span>
// 											</div>
// 											<span className='small text-muted'>{row.speedText}</span>
// 										</div>
// 										<div
// 											className='small text-muted text-truncate mt-1'
// 											title={row.address || ''}
// 										>
// 											{row.address || 'Locating…'}
// 										</div>
// 									</div>
// 									)
// 								})
// 							) : (
// 								<div className='text-muted small py-2'>No activity data available.</div>
// 							)}
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 			<DashboardPage />
// 		</>
// 	)
// }

// export { DashboardWrapper }

export default DashboardPage;